// return movements 'Lotteria Italia' as TabListMovements 18'.
export const getLotteryItalyEndpoint =
  '/movimenti-conto-ms/ms/account/movements/getAccountTickets';
export const getLotteryItalyTicketByTsnEndpoint =
  '/movimenti-conto-ms/ms/account/tickets/getTicketByTsn';
